module.exports = __webpack_public_path__ + "static/TiemposTextWeb-RegularItalic-17802b564afccf47c9999e75fb024001.woff";